import React, { useState, useRef } from "react";
import pen from "../../../src/assets/images/pen1.png";
import del from "../../../src/assets/images/del1.png";
import { useDispatch, useSelector } from "react-redux";
import { updateFormField } from "../../pages/Slices/formSlice";
import { toastMsg } from "../toast";
import { Modal } from "react-bootstrap";
import CustomButton from "../button";
import { PostCallWithErrorResponse } from "../../Api/ApiServices";
import { ApiConfig } from "../../Api/ApiConfig";
import AddEditGroup from "../../pages/addEditGroup";
import EditSkillGroup from "./editSkillgroup";

export default function NewSkill({ loadingForRegenerateSkills, regenerateSkillsAPI, setIsEditGroup, isEditGroup }) {
  // const [isEditGroup, setIsEditGroup] = useState(false);
  const [isRegenerating, setISRegenarting] = useState(false);
  const ref = useRef(null);
  const [isAddSkill, setIsAddSkill] = useState(false);
  const [skillName, setSkillName] = useState("");
  const [newSkills, setNewSkills] = useState([]);
  const [feedback, setFeedback] = useState("");
  const [groupDetails, setGroupDetails] = useState({
    index: -1,
    group: [],
  });
  const state = useSelector((state) => state?.form);
  const dispatch = useDispatch();
  const handleSkillClick = (skill, groupIndex = groupDetails.index) => {
    const updatedGroups = [...state.skillsRequiredForJob];

    const updatedGroup = { ...updatedGroups[groupIndex] };

    const currentSkills = updatedGroup?.recommended_skills || [];

    if (currentSkills.includes(skill)) {
      updatedGroup.recommended_skills = currentSkills.filter(
        (s) => s !== skill
      );
    } else {
      updatedGroup.recommended_skills = [...currentSkills, skill];

      console.log(updatedGroup, "temp");
    }

    updatedGroups[groupIndex] = updatedGroup;
    dispatch(
      updateFormField({ field: "skillsRequiredForJob", value: updatedGroups })
    );
  };

  const removeSkill = (index, skill, isRecomented = false) => {
    if (state?.skillsRequiredForJob?.includes(skill)) {
      let filt = state?.skillsRequiredForJob?.filter((i) => i != skill);

      dispatch(updateFormField({ field: "skillsRequiredForJob", value: filt }));
    }

    let updatedGroups = state?.generatedSkillsArray.map((group, i) => {
      if (i === index) {
        return {
          ...group,
          recommended_skills: isRecomented
            ? group?.recommended_skills?.filter((s) => s !== skill)
            : group?.recommended_skills,
          unrecommended_skills: !isRecomented
            ? group?.unrecommended_skills?.filter((s) => s !== skill)
            : group?.unrecommended_skills,
        };
      }
      return group;
    });

    dispatch(
      updateFormField({ field: "generatedSkillsArray", value: updatedGroups })
    );
  };

  const removeSkillGroup = (index) => {
    if (state?.generatedSkillsArray?.length === 1) {
      toastMsg("error", " 1 Group Is Required");
      return;
    }

    let updatedGroups = [];
    state?.generatedSkillsArray.forEach((group, i) => {
      if (index != i) updatedGroups.push(group);
    });

    let skill = [];

    state?.skillsRequiredForJob.forEach((group, i) => {
      if (index != i) skill.push(group);
    });

    dispatch(updateFormField({ field: "skillsRequiredForJob", value: skill }));
    dispatch(
      updateFormField({ field: "generatedSkillsArray", value: updatedGroups })
    );
  };

  const handleClose = () => {
    setIsEditGroup(false);

    setGroupDetails({
      index: -1,
      group: [],
    });

    setNewSkills([]);
  };

  const handleAddSkill = () => {
    ref.current?.focus();
    setIsAddSkill(true);
  };

  const addDeleteSkill = (isDelete = false, skill = "") => {
    const finalSkill = isDelete ? skill : skillName?.trim();

    if (!isDelete && finalSkill.length === 0) {
      return;
    }

    const existingSkills = groupDetails?.group?.recommended_skills || [];

    if (!isDelete && existingSkills.includes(finalSkill)) {
      toastMsg("error", "Skill Name Already Added");
      return;
    }

    if (existingSkills.length >= 12 && !isDelete) {
      toastMsg("error", "Only 12 keywords can be added in a group");
      return;
    }

    setGroupDetails((prev) => ({
      ...prev,
      group: {
        ...prev.group,
        recommended_skills: isDelete
          ? prev.group?.recommended_skills?.filter((i) => i !== finalSkill)
          : [...prev.group?.recommended_skills, finalSkill],
      },
    }));

    const currentGroups = [...state.skillsRequiredForJob];
    const targetGroup = { ...currentGroups[groupDetails.index] };

    let updatedSkills;

    if (isDelete) {
      updatedSkills = targetGroup?.recommended_skills?.filter(
        (i) => i !== finalSkill
      );
    } else {
      if (targetGroup?.recommended_skills?.length < 8) {
        updatedSkills = [...targetGroup?.recommended_skills, finalSkill];
      }
    }

    targetGroup.recommended_skills = updatedSkills;
    currentGroups[groupDetails?.index] = targetGroup;

    if (updatedSkills) {
      dispatch(
        updateFormField({
          field: "skillsRequiredForJob",
          value: currentGroups,
        })
      );
    }

    setSkillName("");
    setIsAddSkill(false);
  };

  const extractBehaviorTitles = (array) => {
    return array?.map((item) => item?.title);
  };

  const handleSave = () => {
    let temp = [...state?.generatedSkillsArray];

    temp.splice(groupDetails?.index, 1, groupDetails.group);

    console.log(temp);

    dispatch(updateFormField({ field: "generatedSkillsArray", value: temp }));

    handleClose();
  };

  const regenerateGroup = () => {
    setISRegenarting(true);

    let org = [];

    org.push(groupDetails.group);

    let payload = {
      company_details: {
        company_name: state.companyName,
        industry: state.industry,
        company_size: state.companySize,
        location: state.location,
        company_type: state.companyType,
        company_description: state.companyDescription,
        company_website: state.website,
      },
      job_details: {
        job_title: state.jobTitle,
        no_of_positions: state.noOfPositions,
        job_department: state.department,
        job_location: state.locationJobDetails,
        job_language: state.anyLanguageOtherThanEnglish,
        job_type: state.jobType,
        workplace_type: state.workPlaceType,
        job_description: state.descriptionAboutJob,
        experience_required: state.experience,
        salary_range: state.salary,
        job_qualifications: state.minEducationQualification,
        travel_requirements: state.travelRequirement,
      },
      behaviors: extractBehaviorTitles(state?.behaviorsDataApi?.selectedByUser),
      selected_keywords: state?.selectedKeywords,
      original_section: org,
      feedback: feedback,
    };

    PostCallWithErrorResponse(ApiConfig.REGENERATE_SKILL, payload).then(
      (res) => {
        if (res?.json?.status == 200) {
          setGroupDetails((prev) => ({
            ...prev,
            group: res?.json?.skill_groups?.skill_groups[0],
          }));

          let temp = [...state?.skillsRequiredForJob];
          let group = res?.json?.skill_groups?.skill_groups[0];
          temp.splice(groupDetails.index, 1, group);

          console.log(temp, "temp");

          dispatch(
            updateFormField({ filed: "skillsRequiredForJob", value: temp })
          );
        }
        setISRegenarting(false);
        setFeedback("");
      }
    );
  };

  return (
    <div>
      <main className="flex-1 p-10 bg-white">
        <div
          className="col-md-12"
        // style={{ padding: "16px", paddingTop: "0px", marginTop: "8px" }}
        >
          <div className="sec1">
            {(!state?.isView || state?.isEdit)
              ? state?.finalSkillsArray?.map((group, index) => {
                return (
                  <div className="skillBox">
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 style={{ fontSize: "11px", fontWeight: "500" }}>
                        {group?.group_name}
                      </h6>
                      {/* <div>
                        <img
                          src={pen}
                          height={25}
                          width={25}
                          alt="edit"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsEditGroup(true);
                            setGroupDetails({
                              index: index,
                              group: group,
                            });
                          }}
                        />
                        <img
                          src={del}
                          height={25}
                          width={25}
                          alt="delete"
                          onClick={() => removeSkillGroup(index)}
                        />
                      </div> */}
                    </div>
                    <div className="d-flex flex-wrap " style={{ gap: "8px" }}>
                      {group?.recommended_skills?.length > 0 && group?.recommended_skills?.map((skill, indx) => {
                        return (
                          <div
                            key={indx}
                            className={`${state?.skillsRequiredForJob[
                              index
                            ]?.recommended_skills?.includes(skill)
                              ? "mar-key--v2"
                              : " sk-5"
                              }  rounded-full text-sm  px-3 py-1  flex items-center  `}
                            onClick={() => handleSkillClick(skill, index)}
                            style={{ marginTop: "0px", cursor: 'pointer' }}
                          >
                            {skill}

                          </div>
                        );
                      })}
                      {group?.unrecommended_skills?.length > 0 && group?.unrecommended_skills?.map((skill, indx) => {
                        return (
                          <div
                            key={indx}
                            className={`${state?.skillsRequiredForJob[
                              index
                            ]?.recommended_skills?.includes(skill)
                              ? "mar-key--v2"
                              : " sk-5"
                              }  text-blue-800 rounded-full text-sm  px-3 py-1  flex items-center  `}
                            onClick={(e) => handleSkillClick(skill, index)}
                            style={{ cursor: 'pointer' }}
                          >
                            {skill}

                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })
              :

              state?.skillsRequiredForJob?.map((group, index) => {

                return <div className="skillBox">
                  <div className="d-flex justify-content-between align-items-center" >
                    <h6 style={{ fontSize: '11px', fontWeight: '500', }} >{group?.group_name}</h6>

                  </div>
                  <div
                    className="d-flex flex-wrap "
                    style={{ gap: "8px" }}
                  >
                    {
                      group?.recommended_skills?.length > 0 && group?.recommended_skills?.map((skill, indx) => {
                        return <div
                          key={indx}
                          className={`${state?.skillsRequiredForJob[index]?.recommended_skills?.includes(skill) ? "mar-key--v2" : " sk-5"}  rounded-full text-sm  px-3 py-1  flex items-center  `}

                          style={{ marginTop: '0px' }}
                        >
                          {skill}

                        </div>
                      })
                    }

                  </div>


                </div>
              }
              )}

          </div>
        </div>
      </main>
      <Modal show={isEditGroup} centered onHide={handleClose} size="lg">
        {/* <Modal.Header closeButton className="custom-close-btn p-4 pb-3">
          <h5 className="mb-0 fw-bold"> Skills Selection</h5>
        </Modal.Header> */}
        <Modal.Body className="p-4 pt-2">
          <EditSkillGroup handleClose={handleClose} loadingForRegenerateSkills={loadingForRegenerateSkills} regenerateSkillsAPI={regenerateSkillsAPI} />
          {/* <div>
            <div className="d-flex gap-2 align-items-center mb-2">
              <input
                placeholder="Name Of The Skill Group"
                value={groupDetails?.group?.group_name}
                onChange={(e) => {
                  setGroupDetails((prev) => ({
                    ...prev,
                    group: {
                      ...prev.group,
                      group_name: e.target.value,
                    },
                  }));
                }}
                className="w-full rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                style={{ width: "60%", height: "38px" }}
              />
              <CustomButton
                title="Save"
                buttonType="secondary"
                handleClick={handleSave}
              />
            </div>
            <div className="skillBoxadd mt-2">
              {groupDetails?.group?.recommended_skills?.map((skill, index) => {
                return (
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-2 mt-1">
                      <input
                        type="checkbox"
                        style={{ margin: 0 }}
                        checked={state?.skillsRequiredForJob?.[
                          groupDetails.index
                        ]?.recommended_skills?.includes(skill)}
                        onClick={(e) => handleSkillClick(skill)}
                        disabled={
                          state?.skillsRequiredForJob?.[groupDetails.index]
                            ?.recommended_skills?.length == 8 &&
                          !state?.skillsRequiredForJob?.[
                            groupDetails.index
                          ]?.recommended_skills?.includes(skill)
                        }
                      />
                      <h6
                        className="mb-0"
                        style={{ fontSize: "10px", fontWeight: "500" }}
                      >
                        {skill}
                      </h6>
                    </div>
                    <img
                      src={del}
                      height={25}
                      width={25}
                      alt="delete"
                      style={{ cursor: "pointer" }}
                      onClick={() => addDeleteSkill(true, skill)}
                    />
                  </div>
                );
              })}
            </div>
            <div className="mt-1">
              {isAddSkill && (
                <div className="d-flex gap-2 align-items-center">
                  <input type="checkbox" style={{ margin: 0 }} />
                  <input
                    placeholder="Name Of The Skill Group"
                    ref={ref}
                    value={skillName}
                    onBlur={() => addDeleteSkill()}
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        addDeleteSkill();
                      }
                    }}
                    onChange={(e) => setSkillName(e.target.value)}
                    className="w-full rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
                    style={{ width: "60%", height: "38px" }}
                  />
                </div>
              )}
            </div>
            <div>
              <CustomButton
                isDisabled={
                  groupDetails?.group?.recommended_skills?.length == 12
                }
                title="+ Add Skill"
                buttonType="tertiory"
                handleClick={handleAddSkill}
              />
            </div>
            <div className="addSkillDes mt-2">
              <li style={{ fontSize: "10px", fontWeight: "500" }}>
                Each group must have at least 5 skill
              </li>
              <li style={{ fontSize: "10px", fontWeight: "500" }}>
                You can add up to 12 skill per group
              </li>
              <li style={{ fontSize: "10px", fontWeight: "500" }}>
                You may select a maximum 70% of the skills in any group
              </li>
            </div>
            <div className="mt-3">
              <textarea
                placeholder="Type your instruction hire"
                name="descriptionAboutJob"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                rows={4}
                className="w-full p-2 rounded-md bg-gray-100 border border-grey text-black jb-in-1 "
              />
              <div className="d-flex justify-content-end mt-2">
                <CustomButton
                  title="Regenerate"
                  isLoading={isRegenerating}
                  handleClick={regenerateGroup}
                />
              </div>
            </div>
          </div> */}
        </Modal.Body>
      </Modal>
    </div>
  );
}
